import { StateType } from "@/redux/createStore";
import { createSelector } from "reselect";

export const getCrudProduct = createSelector(
  (state: StateType) => state.crudProduct,
  (data) => data
);
